// @generated by web/tools/codegen — DO NOT EDIT

/**
 * Static-page SEO registry (ADR 0142) — generated from the `ogType`-bearing
 * `public_routes` nodes of the ROOT manifests/routes.yaml (the public-URL SSOT).
 * Keyed by canonical path; each static-SEO route maps to its og:type + the
 * robots policy its `indexable:` flag means. Title/description copy stays in
 * i18n; this registry drives canonical/hreflang/robots (useStaticSeo). The
 * path union is the set of statically-SEO’d routes.
 */

export type StaticSeoRoutePath = '/about' | '/contact' | '/feedback' | '/forms' | '/help' | '/partners' | '/privacy' | '/services' | '/terms' | '/tools' | '/tools/affordability-calculator' | '/tools/buy-vs-rent-calculator' | '/tools/chinese-converter' | '/tools/hk-school-map' | '/tools/mortgage-calculator' | '/tools/rates-government-rent-calculator' | '/tools/rental-yield-calculator' | '/tools/stamp-duty-calculator';

/**
 * The closed og:type vocabulary — derived from the routes-model `OgType`
 * parse enum (R3 PR-C), so a routes.yaml `ogType` value outside this union
 * is unrepresentable, and `SeoMeta['ogType']` accepting this union is what
 * ties the yaml vocabulary to the `common.v1.OgType` wire mirror.
 */
export type OgTypeString = 'website' | 'article' | 'product' | 'profile';

/**
 * The robots policies a ROUTE-level `indexable:` flag can mean — `index`
 * for `indexable: true`, `noindex-nofollow` for `indexable: false`. A
 * strict subset of the web `RobotsPolicy` union (`noindex-follow` is a
 * per-RESOURCE decision the backend makes, never a route-level one). The
 * hand-written `lib/seo/robots.ts` pins the subset relation by assigning
 * these values through a `RobotsPolicy` annotation, so a generator that
 * emitted an unrenderable spelling would be a compile error there.
 */
export type RouteRobotsPolicy = 'index' | 'noindex-nofollow';

export interface StaticSeoEntry {
  /** OpenGraph og:type (e.g. 'website'). */
  readonly ogType: OgTypeString;
  /** Robots policy, derived from this route's `indexable:` flag. */
  readonly robots: RouteRobotsPolicy;
}

export const staticSeo = {
  '/about': { ogType: 'website', robots: 'index' },
  '/contact': { ogType: 'website', robots: 'index' },
  '/feedback': { ogType: 'website', robots: 'index' },
  '/forms': { ogType: 'website', robots: 'index' },
  '/help': { ogType: 'website', robots: 'index' },
  '/partners': { ogType: 'website', robots: 'index' },
  '/privacy': { ogType: 'website', robots: 'index' },
  '/services': { ogType: 'website', robots: 'index' },
  '/terms': { ogType: 'website', robots: 'index' },
  '/tools': { ogType: 'website', robots: 'index' },
  '/tools/affordability-calculator': { ogType: 'website', robots: 'index' },
  '/tools/buy-vs-rent-calculator': { ogType: 'website', robots: 'index' },
  '/tools/chinese-converter': { ogType: 'website', robots: 'index' },
  '/tools/hk-school-map': { ogType: 'website', robots: 'index' },
  '/tools/mortgage-calculator': { ogType: 'website', robots: 'index' },
  '/tools/rates-government-rent-calculator': { ogType: 'website', robots: 'index' },
  '/tools/rental-yield-calculator': { ogType: 'website', robots: 'index' },
  '/tools/stamp-duty-calculator': { ogType: 'website', robots: 'index' },
} as const satisfies Record<StaticSeoRoutePath, StaticSeoEntry>;

/**
 * The routes the SSOT declares NON-indexable, each with the policy that
 * flag means — the registry behind the web `noIndexRoute(id)` door.
 *
 * Its key set is the closed argument domain of that door, so a page can
 * only declare itself noindex by naming a route routes.yaml agrees is
 * noindex; flipping the flag to `true` deletes the key and the page that
 * declared itself noindex stops COMPILING, instead of quietly
 * contradicting the sitemap.
 */
export const NON_INDEXABLE_ROUTE_ROBOTS = {
  'account/listing-detail': 'noindex-nofollow',
  'account/listings': 'noindex-nofollow',
  'account/profile': 'noindex-nofollow',
  'account/saved': 'noindex-nofollow',
  'account/settings': 'noindex-nofollow',
  'account/support': 'noindex-nofollow',
  'conversations/index': 'noindex-nofollow',
  'conversations/thread': 'noindex-nofollow',
  'listing-detail/inquiry': 'noindex-nofollow',
  'listings/index': 'noindex-nofollow',
  'marketing/blog-legacy-post': 'noindex-nofollow',
  'marketing/news-legacy': 'noindex-nofollow',
  'marketing/news-legacy-post': 'noindex-nofollow',
  'preview/post': 'noindex-nofollow',
  'wizard/address': 'noindex-nofollow',
  'wizard/amenities': 'noindex-nofollow',
  'wizard/description': 'noindex-nofollow',
  'wizard/media': 'noindex-nofollow',
  'wizard/new-listing': 'noindex-nofollow',
  'wizard/payment': 'noindex-nofollow',
  'wizard/pricing': 'noindex-nofollow',
  'wizard/size': 'noindex-nofollow',
} as const satisfies Record<string, RouteRobotsPolicy>;

/** A route id `manifests/routes.yaml` marks `indexable: false`. */
export type NonIndexableRouteId = keyof typeof NON_INDEXABLE_ROUTE_ROBOTS;
